
import React from 'react';

interface DotTextProps {
  text?: string;
}

export default function DotText({ text }: DotTextProps) {
  return (
    <div className="w-full flex items-start justify-start gap-[8px]">
      <div className="flex items-start justify-start text-[20px] mt-[-4px]">･</div>
      <div className="text-[14px] text-[#363636] w-full text-left font-[400] leading-[22px]">
        {text?.split('\n').map((line, index) => (
          <React.Fragment key={index}>
            {line}
            {index < (text?.split('\n').length || 0) - 1 && <br />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

